import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  productBundleComponentsInventoryTitle: {
    description: 'products details, inventory tab, bundles component inventory levels header',
    defaultMessage: 'Bundle Components Inventory',
    id: 'SfVr1D',
  },
  productBundleInventoryTotalAvailable: {
    description: 'products details, inventory tab, bundles total available',
    defaultMessage: 'Total Available Bundles: {total}',
    id: 'O9WTKq',
  },
  productBundleComponent: {
    description: 'products details, bundles tab, component header',
    defaultMessage: 'Component',
    id: 'xx6tZd',
  },
  productBundleComponentSku: {
    description: 'products details, bundles tab, component sku header',
    defaultMessage: 'SKU: {sku}',
    id: 's6fy/C',
  },
  productBundleComponentName: {
    description: 'products details, bundles tab, component name header',
    defaultMessage: 'Name',
    id: 'ESkKsE',
  },
  productBundleComponentOnHand: {
    description: 'products details, inventory tab, component on hand header',
    defaultMessage: 'On Hand',
    id: 'huUWFh',
  },
  productBundleComponentQtyRequired: {
    description: 'products details, inventory tab, component quantity required header',
    defaultMessage: 'Qty Required',
    id: 'fuXHz1',
  },
  productBundleComponentAllocated: {
    description: 'products details, inventory tab, component allocated header',
    defaultMessage: 'Allocated',
    id: 'rV7hIp',
  },
  productBundleComponentAvailable: {
    description: 'products details, inventory tab, component available header',
    defaultMessage: 'Available',
    id: 'NtBfmi',
  },
  productBundleComponentRemove: {
    description: 'products details, bundles tab, component remove header',
    defaultMessage: 'Remove',
    id: 'pByHph',
  },
  productBundleComponentAdd: {
    description: 'products details, bundles tab, add component button',
    defaultMessage: 'Add',
    id: 'VqL1fd',
  },
  bundleForSku: {
    description: 'products details, bundles tab, label for individual bundle',
    defaultMessage: 'Bundle for {sku}',
    id: 'fVIYpe',
  },
  bundleTotalAvailableNoteHelperText: {
    description: 'products details, bundles tab, helper text',
    defaultMessage:
      'The number of bundles that could be assembled and sold by taking available stock levels and the quantity required and calculating which component product will run out of stock first.',
    id: 'TlUphk',
  },
  bundleInventoryHelperText: {
    description: 'product details, bundles tab, helper text',
    defaultMessage: 'Bundled products themselves <b>do not have inventory</b>. They are a collection of other products.',
    id: 'WHX+To',
  },
});
